/** Pabau's own error message, as forwarded by `/api/lead` and `/api/prescription`, if any. */
export function pabauErrorMessage(error: unknown) {
  const message = (error as { data?: { data?: { pabauMessage?: unknown } } })?.data?.data?.pabauMessage
  return typeof message === 'string' && message ? message : undefined
}
